import React from 'react'
import { Create, useForm, useSelect } from '@refinedev/antd'
import { Form, Input, Select, Switch } from 'antd'
import type { Tables } from '@muaa/shared'

type Notification = Tables<'notifications'>
type Profile = Tables<'profiles'>

const GRP_OPTIONS = [
  { value: 'Today', label: 'Today' },
  { value: 'This Week', label: 'This Week' },
  { value: 'Earlier', label: 'Earlier' },
]

export function NotificationCreate() {
  const { formProps, saveButtonProps } = useForm<Notification>()

  const { selectProps: profileSelectProps } = useSelect<Profile>({
    resource: 'profiles',
    optionLabel: 'name',
    optionValue: 'user_id',
    pagination: { mode: 'off' },
  })

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical" initialValues={{ unread: true }}>
        <Form.Item
          label="Recipient"
          name="user_id"
          rules={[{ required: true, message: 'Recipient is required' }]}
        >
          <Select
            {...profileSelectProps}
            placeholder="Select recipient"
            showSearch
            filterOption={(input, option) =>
              String(option?.label ?? '')
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </Form.Item>

        <Form.Item
          label="Group"
          name="grp"
          rules={[{ required: true, message: 'Group is required' }]}
        >
          <Select placeholder="Select group" options={GRP_OPTIONS} />
        </Form.Item>

        <Form.Item
          label="Icon"
          name="icon"
          rules={[{ required: true, message: 'Icon is required' }]}
        >
          <Input placeholder="e.g. bell, star, gift" />
        </Form.Item>

        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: 'Title is required' }]}
        >
          <Input placeholder="Notification title" />
        </Form.Item>

        <Form.Item
          label="Body"
          name="body"
          rules={[{ required: true, message: 'Body is required' }]}
        >
          <Input.TextArea rows={3} placeholder="Notification body text" />
        </Form.Item>

        <Form.Item
          label="Time"
          name="time"
          rules={[{ required: true, message: 'Time is required' }]}
        >
          <Input placeholder="e.g. 2h ago, Just now" />
        </Form.Item>

        <Form.Item label="Unread" name="unread" valuePropName="checked">
          <Switch defaultChecked />
        </Form.Item>
      </Form>
    </Create>
  )
}
